import { useQuery } from '@tanstack/react-query'
import { patientApi } from '@/services/patient.service'
import { ClinicalSummary } from '@/types'

const STALE_TIME_MS = 30_000

/**
 * Fetches the read-only current clinical summary for a patient.
 * The summary is derived from signed consultations, prescriptions, and
 * self-reported allergies; it is recomputed on the backend on each read.
 */
export function useClinicalSummary(patientId: string | undefined) {
  return useQuery<ClinicalSummary, Error>({
    queryKey: ['clinical-summary', patientId],
    queryFn: async () => {
      if (!patientId) throw new Error('Patient ID is required')
      return patientApi.getClinicalSummary(patientId)
    },
    enabled: !!patientId,
    staleTime: STALE_TIME_MS,
  })
}
